const context = "integracao";
const abrev = "integra";

export default [
    {
        path: '/integracao/',
        name: 'integracao',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/integracao/Integracao.vue'),
        children: [
            {
                path: 'list',
                name: 'integracao-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/integracao/IntegracaoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'integracao-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/integracao/IntegracaoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'integracao-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/integracao/IntegracaoManage.vue')
                    },
                ]
            },
        ]
    },
];
